export const filterTypes = {
  DISPLAY_BOOKS: "DISPLAY_BOOKS",
  SEARCH_FILTER: "SEARCH_FILTER",
  SORT_FILTER: "SORT_FILTER",
  RATING_FILTER: "RATING_FILTER",
  CATEGORY_FILTER: "CATEGORY_FILTER",
  CLEAR_FILTER: "CLEAR_FILTER",
  GET_PRODUCT_DETAILS: "GET_PRODUCT_DETAILS",
};
